import { useState } from 'react';
import { MAX_CUSTOM_CSS } from '../../lib/sanitizeCss';
import { LAYOUTS, THEMES, useSettings } from '../../store/settings';
import { Choice, ghostButtonClass, Section } from './controls';

const EXAMPLE = `/* Examples */
.glass { border-radius: 0.5rem; }
:root { --accent: #f472b6; }`;

export function AppearanceTab() {
  const layout = useSettings((s) => s.layout);
  const theme = useSettings((s) => s.theme);
  const customCss = useSettings((s) => s.customCss);
  const update = useSettings((s) => s.update);
  const reset = useSettings((s) => s.reset);
  const [confirmReset, setConfirmReset] = useState(false);

  return (
    <>
      <Section title="Layout">
        <Choice options={LAYOUTS} value={layout} onChange={(v) => update('layout', v)} />
      </Section>
      <Section title="Theme">
        <Choice options={THEMES} value={theme} onChange={(v) => update('theme', v)} columns={3} />
      </Section>
      <Section
        title="Custom CSS"
        description="Advanced: override any style. Changes apply live. Imports, scripts and non-HTTPS images are removed for safety."
      >
        <textarea
          value={customCss}
          onChange={(e) => update('customCss', e.target.value.slice(0, MAX_CUSTOM_CSS))}
          placeholder={EXAMPLE}
          spellCheck={false}
          rows={10}
          className="w-full rounded-lg border border-[var(--border)] bg-black/30 p-3 font-mono text-xs outline-none focus:border-[var(--accent)]"
          aria-label="Custom CSS"
        />
        <div className="muted text-right text-xs">
          {customCss.length.toLocaleString()} / {MAX_CUSTOM_CSS.toLocaleString()}
        </div>
      </Section>
      <Section title="Reset">
        {confirmReset ? (
          <div className="flex gap-2">
            <button
              className={`${ghostButtonClass} border-red-400 text-red-400`}
              onClick={() => {
                reset();
                setConfirmReset(false);
              }}
            >
              Yes, reset all settings
            </button>
            <button className={ghostButtonClass} onClick={() => setConfirmReset(false)}>
              Cancel
            </button>
          </div>
        ) : (
          <button className={ghostButtonClass} onClick={() => setConfirmReset(true)}>
            Reset settings on this screen
          </button>
        )}
      </Section>
    </>
  );
}
